<div fxLayout="row" fxLayoutAlign="space-between start" class="incidencia" (click)="showMarker();">
    <img width="30px" src={{iconUrl}} alt="Icona incidència">

    <div fxFlex="90%">
        <span class="title">{{road}} (Km {{start_kp}} - {{end_kp}})</span>

        <div class="details">
            <div *ngIf="city">
                <span class="detail-name" i18n>Ciudad:</span> {{ city }}
            </div>
    
            <div *ngIf="cause">
                <span class="detail-name" i18n>Causa:</span> {{ cause }}
            </div>
    
            <div *ngIf="comments">
                <span class="detail-name" i18n>Comentarios:</span> {{ comments }}
            </div>
    
            <div *ngIf="direction">
                <span class="detail-name" i18n>Dirección:</span> {{ direction }}
            </div>
        </div>

        <div class="source" i18n>
            Fuente: {{ source }}
        </div>
    </div>
        
</div>
    
    